import { useForm } from 'react-hook-form';
import {
  ExportAccountingTransferOrderFormValues,
  exportAccountingTransferOrderFormResolver,
} from './schema';

export type ExportAccountingTransferOrderUseForm = ReturnType<
  typeof useForm<ExportAccountingTransferOrderFormValues>
>;

export const useExportAccountingTransferOrderUseForm = (
  defaultValues?: Partial<ExportAccountingTransferOrderFormValues>,
) => {
  const exportAccountingTransferOrderForm =
    useForm<ExportAccountingTransferOrderFormValues>({
      resolver: exportAccountingTransferOrderFormResolver,
      defaultValues: {
        ...defaultValues,
      },
    });

  return { exportAccountingTransferOrderForm };
};
